import urlSettings from '@/config/url-settings';
import { Base64 } from 'js-base64';

/* 坐席状态映射 */
export let operatorStatusMap = {
  offline: 0, // 离线
  ready: 1, // 就绪
  incall: 2, // 通话中
  aftercall: 3, // 话后处理
  away: 4, // 离席
};

/**
 * 将秒数转成“hh:mm:ss”或“hh时mm分ss秒”格式
 * @param {number} seconds 秒数
 * @param {string} separator 分隔符格式，默认为“:”，若为“chi”则使用“时分秒”分隔
 * @returns
 */
export function secondsToDuration(seconds, separator) {
  let linkArr = [];
  if (separator == 'chi') {
    linkArr = ['时', '分', '秒'];
  } else {
    linkArr = [':', ':', ''];
  }
  if (seconds < 0) return 0;
  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);
  let remainingSeconds = seconds % 60;
  let timeStr = '';
  if (hours > 0) {
    timeStr += hours.toString().padStart(2, '0') + linkArr[0];
  }
  timeStr +=
    minutes.toString().padStart(2, '0') +
    linkArr[1] +
    remainingSeconds.toString().padStart(2, '0') +
    linkArr[2];

  return timeStr;
}

/* 在线预览文件 */
export function onlinePreviewFile(url) {
  let fullUrl = '';
  if (process.env.NODE_ENV === 'development') {
    fullUrl = process.env.VUE_APP_FILE_VIEW_URL;
  } else {
    fullUrl = urlSettings.FILE_VIEW_URL;
  }
  fullUrl += encodeURIComponent(Base64.encode(url));
  window.open(fullUrl);
}
